import axiosInstance from "../utils/api";

const externalLoginService = {
    verifyUserEmail: async (emailId) => {
        try {
            const result = await axiosInstance.post(`/ExternalLogin/verify-user-email-id?token=${emailId}`);
            return result;
        } catch (error) {
            return error.response;
        }
    },


    setPassowrd: async (payload) => {
        try {
            const result = await axiosInstance.post("/ExternalLogin/set-password", payload);

            return result;
        } catch (error) {
            return error.response;
        }
    },

    verifyOtp: async (payload) => {
        try {
            const result = await axiosInstance.post("/ExternalLogin/verify-otp", payload);
            return result;
        } catch (error) {
            return error;
        }
    },

    resendOtp: async (payload) => {
        try {
            const result = await axiosInstance.post("/ExternalLogin/resend-otp", payload);
            return result;
        } catch (error) {
            return error.response;
        }
    },

    externalLogin: async (payload) => {
        try {
            const result = await axiosInstance.post("/ExternalLogin/login", payload);
            return result;
        } catch (error) {
            return error.response;
        }
    },

    forgotPassword: async (payload) => {
        try {
            const result = await axiosInstance.post("/ExternalLogin/forgot-password", payload);
            return result;
        } catch (error) {
            return error.response;
        }
    },


    resetPassword: async (payload) => {
        try {
            const result = await axiosInstance.post("/ExternalLogin/reset-password", payload);
            return result;
        } catch (error) {
            return error.response;
        }
    },

    externalLogout: async () => {
        try {
            const result = await axiosInstance.post("/externallogin/logout");
            return result;
        } catch (error) {
            return error.response;
        }
    },

    forceLogin: async (payload) => {
        try {
            const result = await axiosInstance.post("/ExternalLogin/force-verify-login", payload);
            return result;
        } catch (error) {
            return error.response;
        }
    },

};

export default externalLoginService;
